export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const PROTOCOL_PREFIX_LEGACY = 'chatwoot-widget:';
export const PROTOCOL_PREFIX_V2 = 'vh-widget:';

// Диалект postMessage выбирает лоадер: новый передаёт в url iframe `p=2`, старый
// (в том числе закэшированные на чужих сайтах копии) не передаёт ничего и
// остаётся на legacy-префиксе. Никакой эвристики — родитель объявляет диалект
// раньше, чем iframe отправит первое сообщение.
export const getProtocolPrefix = (search = window.location.search) =>
  new URLSearchParams(search).get('p') === '2'
    ? PROTOCOL_PREFIX_V2
    : PROTOCOL_PREFIX_LEGACY;
